export default class ProducerConfiguration {
    maxOfferQuantities: number[] = null;
    maxErpQuantities: number[] = null;
    maxDailyQuantities: number[] = null;
    maxCropYearQuantities: number[] = null;
    producerDefaults: ProducerDefaults = null;
}

export class ProducerDefaults {
    willSellDefaultValue: boolean = false;
    canMakeOffer: boolean = false;
    maxOfferQuantity: number = 0;
    maxDailyQuantity: number = 0;
    maxCropYearQuantity: number = 0;
    maxErpQuantity: number = 0;
    preferredLocationId: string = null;
    preferredTraderId: string = null;
}

export const ProducerDefaultValues = {
    maxOfferQuantity: 45_000,
    maxErpQuantity: 5000,
    maxDailyQuantity: 45_000,
    maxCropYearQuantity: 250_000
}